export const ssr = false;

import * as db from '$lib/api';

export async function load({fetch})
{
    return {
        translations: await db.fetchTranslations(fetch),
        languages: await db.fetchLanguages(fetch),
        categories: await db.fetchCategories(fetch),
        places: await db.fetchPlaces(fetch),
    };
}
